export default __webpack_public_path__ + "static/media/DarkBlue0006.d60f3b4e.png";